<template>
  <div class="media-account-page">
    <layout>
      <template v-slot:search>
        <div class="search-wrapper">
          <div class="title"><a-icon type="search" /> 数据筛选</div>
          <a-divider></a-divider>
          <a-space>
            <a-select show-search allow-clear placeholder="所属主体" v-model="queryParam.corporation_id"  option-filter-prop="children">
              <a-select-option :value="corporation.id" v-for="corporation in corporations" :key="corporation.id" >
                {{ corporation.name }}
              </a-select-option>
            </a-select>
            <a-select allow-clear placeholder="投放媒体" v-model="queryParam.media" show-search option-filter-prop="children" :dropdown-match-select-width="false">
              <a-select-option :value="media.id" v-for="media in medias" :key="media.id" >
                {{ media.name }}
              </a-select-option>
            </a-select>
            <a-select allow-clear placeholder="开放平台类型" v-model="queryParam.open_platform_type" show-search option-filter-prop="children" :dropdown-match-select-width="false">
              <a-select-option :value="item.id" v-for="item in openPlatformTypes" :key="item.id" >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-select allow-clear placeholder="代理商" v-model="queryParam.media_type" show-search option-filter-prop="children" :dropdown-match-select-width="false">
              <a-select-option :value="item.id" v-for="item in mediaTypes" :key="item.id" >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-input allow-clear placeholder="账号名称" v-model="queryParam.name" />
            <a-select v-if="super_or_main" allow-clear placeholder="开发者账号" v-model="queryParam.developer_account_id" show-search option-filter-prop="children" :dropdown-match-select-width="false" style="width: 200px;">
              <a-select-option :value="item.id" v-for="item in developerAccounts" :key="item.id" >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-input allow-clear placeholder="开发者账号ID" v-model="queryParam.out_id" />
            <a-select allow-clear placeholder="付费类型（快手）" v-model="queryParam.pay_type" show-search option-filter-prop="children" :dropdown-match-select-width="false">
              <a-select-option :value="item.id" v-for="item in payTypes" :key="item.id" >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-select allow-clear placeholder="业务类型（快手）" v-model="queryParam.business_type" show-search option-filter-prop="children" :dropdown-match-select-width="false">
              <a-select-option :value="item.id" v-for="item in businessTypes" :key="item.id" >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-button type="primary" @click="search">查询</a-button>
            <a-button @click="resetSearch">重置</a-button>
          </a-space>
        </div>
      </template>

      <template v-slot:content>
        <!-- <a-space class="table-operator">
          <a-button type="primary" icon="plus" @click="create" v-if="accessTo('store')">添加</a-button>
          <a-dropdown :disabled="selectedRowKeys.length === 0" v-if="accessTo('destroy')">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="destroy()"><a-icon type="delete" />删除</a-menu-item>
            </a-menu>
            <a-button> 批量操作 <a-icon type="down" /></a-button>
          </a-dropdown>
        </a-space> -->

        <!-- <a-table
          :columns="columns"
          :row-key="record => record.id"
          :data-source="data"
          :row-selection="{ onChange: onSelectChange }"
          :pagination="pagination"
          :loading="loading"
          @change="handleTableChange"
        > -->

        <vxe-grid
          class="table-scrollbar"
          v-bind="tableGrid"
          @page-change="handlePageChange"
          @sort-change="handleSortChange"
          @checkbox-change="handleRowChange"
          @checkbox-all="handleRowChange"
        >

        <template #toolbar_buttons>
          <a-space class="table-operator">
            <a-button type="primary" icon="plus" @click="create" v-if="accessTo('store')">添加</a-button>
            <a-dropdown :disabled="selectedRowKeys.length === 0" v-if="accessTo('destroy')">
              <a-menu slot="overlay">
                <a-menu-item key="1" @click="destroy()"><a-icon type="delete" />删除</a-menu-item>
              </a-menu>
              <a-button> 批量操作 <a-icon type="down" /></a-button>
            </a-dropdown>
          </a-space>
      </template>
        <template #action="{ row }">
          <div class="actions">
            <template v-if="accessTo(['update', 'destroy'])">
              <a href="javascript:;" @click="copyUrl(row)">回调地址(旧版)</a>
              <a-divider type="vertical" />
              <a href="javascript:;" @click="copyUrl(row, 'new')" v-if="row.media === 2">回调地址(升级版)</a>
              <a-divider type="vertical" />
              <a href="javascript:;" @click="copyUrl(row, 'spi')">SPI回调地址</a>
              <a-divider type="vertical" />
              <a href="javascript:;" @click="openSpiSubscription(row)" v-if="row.media === 1">订阅管理</a>
              <a-divider type="vertical" v-if="row.media === 1" />
              <a href="javascript:;" :disabled="!row.master" @click="create(row)" v-if="accessTo('update')">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认要删除吗?" @confirm="destroy(row)" v-if="accessTo('destroy')">
                <a href="javascript:;" :disabled="!row.master">删除</a>
              </a-popconfirm>
            </template>
            <template v-else>-</template>
          </div>
        </template>
         

        </vxe-grid>

        <!-- </a-table> -->
      </template>
    </layout>
    <create-form
      v-if="showForm"
      :showForm.sync="showForm"
      :model="model"
      @success="refresh"
    />
    <spi-subscription-form
      v-if="showSpiSubscription"
      :showForm.sync="showSpiSubscription"
      :record="spiSubscriptionRecord"
      @success="refresh"
    />
  </div>
</template>

<style lang="less" scoped>
@import 'MediaAccount';
</style>

<script>
import MediaAccount from './MediaAccount'
export default MediaAccount
</script>
